import React, { useState } from "react";
import { Undo2, X } from "lucide-react";
import { toast } from "react-toastify";
import { Button } from "../ui/button";
import TextAreaField from "../ui/TextAreaField";
import { devolverCalibracion } from "../../utils/calibracionRevision";

// Devuelve una calibración al metrólogo con un motivo obligatorio.
const DevolverCalibracionModal = ({ servicio, onClose, onDevuelta }) => {
  const [motivo, setMotivo] = useState("");
  const [enviando, setEnviando] = useState(false);

  if (!servicio) return null;

  const enviar = async () => {
    if (!motivo.trim()) {
      toast.warning("Escribe el motivo de la devolución");
      return;
    }
    setEnviando(true);
    try {
      await devolverCalibracion(servicio._id, motivo.trim());
      toast.success("Calibración devuelta al metrólogo");
      onDevuelta?.(servicio._id);
    } catch (err) {
      toast.error(err.response?.data?.message || "No se pudo devolver la calibración");
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 p-4">
      <div className="w-full max-w-md overflow-hidden rounded-2xl bg-white shadow-xl">
        <div className="flex items-center justify-between border-b px-5 py-4">
          <div className="flex items-center gap-2">
            <Undo2 className="h-5 w-5 text-amber-600" />
            <h3 className="font-semibold text-gray-800">Devolver al metrólogo</h3>
          </div>
          <button
            type="button"
            onClick={onClose}
            disabled={enviando}
            aria-label="Cerrar"
            className="text-gray-400 transition-colors hover:text-gray-600"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        <div className="space-y-3 p-5">
          <p className="text-sm text-gray-600">
            {servicio.equipo?.marca?.name} {servicio.equipo?.modelo?.name} · Serial{" "}
            {servicio.equipo?.serial || "—"}. La calibración vuelve a borrador y
            pierde su sello hasta que el metrólogo la finalice de nuevo.
          </p>
          <TextAreaField
            label="Motivo"
            rows={4}
            maxLength={1000}
            value={motivo}
            onChange={(e) => setMotivo(e.target.value)}
            placeholder="Indica qué debe corregir el metrólogo"
          />
        </div>
        <div className="flex flex-col-reverse gap-2 border-t px-5 py-3 sm:flex-row sm:justify-end">
          <Button type="button" variant="outline" onClick={onClose} disabled={enviando}>
            Cancelar
          </Button>
          <Button
            type="button"
            className="bg-amber-600 hover:bg-amber-700"
            onClick={enviar}
            disabled={enviando}
          >
            {enviando ? "Devolviendo..." : "Devolver calibración"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DevolverCalibracionModal;
